import { render, staticRenderFns } from "./MiniappshaichaWxuserSub.vue?vue&type=template&id=124f784c&scoped=true&"
import script from "./MiniappshaichaWxuserSub.vue?vue&type=script&lang=js&"
export * from "./MiniappshaichaWxuserSub.vue?vue&type=script&lang=js&"
import style0 from "./MiniappshaichaWxuserSub.vue?vue&type=style&index=0&id=124f784c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124f784c",
  null
  
)

export default component.exports